import React from 'react'

import { usePageEditorContext } from '../../contexts/page-editor.context'
import { RichText } from '../../../common/components/rich-text'
import { EmptyBlock } from '../empty-block'

import { useStyles } from './text-block.style'

export const TextBlock = function ({ value, style = {} }) {
  const classes = useStyles()

  const pageEditorContext = usePageEditorContext()

  // TODO: We should move this logic into something editor specific instead of depending on page editor context from
  // this non-editor specific component.
  if (pageEditorContext && value === undefined) {
    return (
      <EmptyBlock>Empty Text Block</EmptyBlock>
    )
  }

  return (
    <div className={classes.content} style={style}>
      <RichText value={value} />
    </div>
  )
}
